import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable.jsx";
import { Spin } from "antd";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_ATTENDANCE,
} from "../RollCallConfig/RollCallConfig.js";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../core/common/footer/commonFooter.jsx";
import FallBackMessage from "../RollCallConfig/FallBackMessage.jsx";

const { RangePicker } = DatePicker;

const Attendance = () => {
  const today = dayjs();
  const tenDaysBefore = today.subtract(10, "day");

  const [attendance, setAttendance] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [startDate, setStartDate] = useState(
    tenDaysBefore.format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));

  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;
    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];

    if (!perms) {
      navigate(`/${userData?.DefaultPath}`);
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);
  const regId = userData?.RegId;

  const disabledDate = (current) => {
    return current && current > today.endOf("day");
  };

  const handleChange = (dates) => {
    if (dates) {
      setStartDate(dates[0].format("YYYY-MM-DD"));
      setEndDate(dates[1].format("YYYY-MM-DD"));
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchAttendance = () => {
    if (tokenData && superIdData) {
      setloading(true);

      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_ATTENDANCE}?regid=${regId}&superid=${superIdData}&fromdate=${startDate}&todate=${endDate}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok)
            throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data?.status) {
            setAttendance(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setAttendance([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  useEffect(() => {
    fetchAttendance(); // Initial fetch
  }, [superIdData, tokenData]);

  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      sorter: (a, b) => a.Date.length - b.Date.length,
    },
    {
      title: "Shift",
      dataIndex: "ActualShift",
      sorter: (a, b) => a.ActualShift?.length - b.ActualShift?.length,
      //   align: "center",
      render: (value) => {
        if (!value) return "-";

        const shift = value.trim().toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (shift) {
          case "general":
            badgeClass = "badge-success";
            break;
          case "morning":
            badgeClass = "badge-info";
            break;
          case "afternoon":
            badgeClass = "badge-secondary";
            break;
          case "nightshift":
            badgeClass = "badge-primary";
            break;
        }

        return <span className={`badge ${badgeClass} badge-xs`}>{value}</span>;
      },
    },
    {
      title: "Clock In",
      dataIndex: "InTime",
      sorter: (a, b) => a.InTime?.length - b.InTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "Clock Out",
      dataIndex: "OutTime",
      sorter: (a, b) => a.OutTime?.length - b.OutTime?.length,
      render: (value) => {
        if (!value) return "-";
        const date = new Date(value);
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      },
    },
    {
      title: "Duration",
      dataIndex: "Duration",
      sorter: (a, b) => a.Duration?.length - b.Duration?.length,
      render: (value) => value || "-",
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text) => {
        const status = text?.toLowerCase();

        let badgeClass = "badge-secondary"; // default
        switch (status) {
          case "present":
            badgeClass = "badge-success";
            break;
          case "late":
            badgeClass = "badge-warning";
            break;
          case "leave":
          case "absent":
            badgeClass = "badge-danger";
            break;
          case "holiday":
            badgeClass = "badge-primary";
            break;
          case "weekoff":
            badgeClass = "badge-secondary";
            break;
          case "No Swipe":
            badgeClass = "badge-danger";
            break;
        }

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
      sorter: (a, b) => a.Status?.length - b.Status?.length,
    },
  ];

  const formatTime = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const generatePDF = () => {
    if (attendance && attendance.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Attendance Report", 14, 10);

    const tableColumn = [
      "Date",
      "Shift",
      "InTime",
      "OutTime",
      "Duration",
      "Status",
    ];
    const tableRows = attendance.map((item) => [
      item.Date || "N/A",
      item.ActualShift || "N/A",
      formatTime(item.InTime) || "N/A",
      formatTime(item.OutTime) || "N/A",
      item.Duration || "N/A",
      item.Status || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Attendance.pdf");
  };

  const handleDownloadExcel = () => {
    if (attendance && attendance.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();

    const wsData = attendance.map((item, index) => ({
      "S.No": index + 1,
      Date: item.Date || "N/A",
      Shift: item.ActualShift || "N/A",
      InTime: formatTime(item.InTime) || "N/A",
      OutTime: formatTime(item.OutTime) || "N/A",
      Duration: item.Duration || "N/A",
      Status: item.Status || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Attendance Report");
    XLSX.writeFile(wb, "Attendance_Report.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  return (
    <>
      <div>
        <div className="page-wrapper pt-5">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/${userData?.DefaultPath}`}>
                          <i className="fas fa-home fa-lg" />
                        </Link>
                      </li>
                      <h4 className="breadcrumb-item " aria-current="page">
                        Attendance
                      </h4>
                    </ol>
                  </nav>
                  <h6>Track Your Daily Attendance</h6>
                </div>
              </div>
              <ul className="table-top-head">
                {perm?.Export && (
                  <>
                    <li>
                      <OverlayTrigger placement="top" overlay={renderTooltip}>
                        <Link onClick={generatePDF}>
                          <ImageWithBasePath
                            src="assets/img/icons/pdf.svg"
                            alt="img"
                          />
                        </Link>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderExcelTooltip}
                      >
                        <Link
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          onClick={handleDownloadExcel}
                        >
                          <ImageWithBasePath
                            src="assets/img/icons/excel.svg"
                            alt="img"
                          />
                        </Link>
                      </OverlayTrigger>
                    </li>
                    <li onClick={() => window.location.reload()}>
                      <OverlayTrigger
                        placement="top"
                        overlay={renderRefreshTooltip}
                      >
                        <Link data-bs-toggle="tooltip" data-bs-placement="top">
                          <RotateCcw />
                        </Link>
                      </OverlayTrigger>
                    </li>
                  </>
                )}
              </ul>
            </div>
            {/* /product list */}

            {perm?.Read ? (
              <div className="card table-list-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <div className="search-set"></div>
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="me-2">
                      <RangePicker
                        defaultValue={[tenDaysBefore, today]}
                        disabledDate={disabledDate}
                        onChange={handleChange}
                        style={{ width: 240 }}
                      />
                    </div>
                    <div className="me-1"></div>
                    <div>
                      <button
                        className="btn btn-primary"
                        onClick={fetchAttendance}
                      >
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body pb-0">
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : attendance.length > 0 ? (
                      <Table columns={columns} dataSource={attendance} />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <FallBackMessage />
            )}
            {/* /product list */}
          </div>
          <CommonFooter />
        </div>
      </div>
    </>
  );
};

export default Attendance;
